<template>
    <div class="container mx-auto px-3 pb-32 md:px-8 2xl:max-w-(--breakpoint-xl)">

        <page-header>
            Custom Attributes
        </page-header>

        <custom-attributes-controls
            v-model="fetchParams"
            @reset="resetFilters()"
            @apply="applyFilters()"></custom-attributes-controls>

        <div v-if="loading"
            class="text-center py-10">
            <vx-icon-loading class="w-9 h-9" spin></vx-icon-loading>
        </div>

        <vx-box color="info"
            v-if="!loading && !list.length"
            class="flex flex-col px-8 py-20 gap-6 items-center text-xl text-slate-500">
            No custom attributes found.
        </vx-box>

        <div v-else-if="list.length"
            class="flex flex-col gap-2">
            <vx-box v-for="item in list"
                :key="item"
                class="text-slate-700 flex items-center p-4 gap-y-1 gap-x-2 justify-between sm:gap-x-4 ">
                <span class="font-mono grow text-sm">{{ item.key }}</span>
                <vx-button @click.prevent="deleteCustomAttribute = item.key"
                    data-test="delete-row"
                    class="shrink-0"
                    type="button"
                    color="muted"
                    outline>
                    Delete
                    <font-awesome-icon widthAuto :icon="faTrash" />
                </vx-button>
            </vx-box>
        </div>
        <div v-if="fetchParams.cursor"
            class="mt-8 flex justify-between items-center w-full gap-10">
            <vx-button @click="loadData()"
                color="muted-dark"
                size="xl"
                data-test="load-more-btn"
                class="grow sm:grow-0">
                Load More
                <font-awesome-icon widthAuto :icon="faSpinner"
                    :spin="loading"></font-awesome-icon>
            </vx-button>
        </div>

        <delete-contact-relationships-modal
            v-model="deleteCustomAttribute"
            type="custom_attribute"
            @deleted="removeFromList"
        />
    </div>
</template>

<script setup>
import { faSpinner, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox, VxButton, VxIconLoading } from '@voxie/frontend-components';
import { onMounted, ref } from 'vue';
import PageHeader from '~/components/general/PageHeader.vue';
import { customAttributesClient } from '~/services';
import CustomAttributesControls from './CustomAttributesControls.vue';
import { useCursorPagination } from '../../../composables/useCursorPagination';
import DeleteContactRelationshipsModal from './DeleteContactRelationshipsModal.vue';

const { list, loading, fetchParams, fetchRecords } = useCursorPagination();

const teamId = Spark.state.currentTeam.id;
const deleteCustomAttribute= ref(null);

const defaultFilters = () => ({
    query: '',
    cursor: null,
});

const resetFilters = () => {
    fetchParams.value = defaultFilters();

    loadData();
};

const applyFilters = () => {
    fetchParams.value = {
        ...fetchParams.value,
        cursor: null,
    }

    loadData();
}

onMounted(() => {
    resetFilters();
});

const loadData = () => {
    fetchRecords(customAttributesClient.list(teamId, {...fetchParams.value}));
};

const removeFromList = (key) => {
    list.value = list.value.filter((item) => item.key !== key);

    if (!list.value.length) {
        loadData();
    }
};
</script>
